/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { AgentExportId } from "../../commons/types/AgentExportId";
import { AgentId } from "../../commons/types/AgentId";
import { AgentExportType } from "./AgentExportType";
import { AccountId } from "../../commons/types/AccountId";
import { EnvironmentId } from "../../commons/types/EnvironmentId";
export const AgentExport = core.serialization.object({
    id: AgentExportId,
    agentId: AgentId,
    exportType: AgentExportType,
    accountId: AccountId,
    environmentId: EnvironmentId,
    createdAt: core.serialization.date(),
    updatedAt: core.serialization.date(),
    deletedAt: core.serialization.date().optional(),
});
